const ProductListPage = () => {
    return (
        <div>
            <h1>Product List Page</h1>
        </div>
    );
}

export default ProductListPage;